const translationPath =
  "page.4uSalesContract.registers.beneficiaryCancellationsReason.";

export const buildTPath = (path: string) => translationPath + path;
